export const SET_ELAB_USER = "SET_ELAB_USER";
export const SET_ELAB_USER_FAILED = "SET_ELAB_USER_FAILED";
export const SET_GRID_API = "SET_GRID_API";
export const SET_STORAGE_LOCATIONS = "SET_STORAGE_LOCATIONS";
export const SET_SAMPLE_TYPES = "SET_SAMPLE_TYPES";
export const SET_SAMPLE_TYPE = "SET_SAMPLE_TYPE";
export const SET_USERNAME = "SET_USERNAME";
export const SET_PASSWORD = "SET_PASSWORD";
export const TOGGLE = "TOGGLE";
export const SET_COL_DEFS = "SET_COL_DEFS";
